import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import verified from "../../../src/verified.json";
import { useTranslation } from "react-i18next";
import TermsAndConditions from "../../components/cdr/TermsAndConditionsModal";
import { getItemOfSessionStorage } from "../../services/common/utils";
import { useSelector } from "react-redux";
const VerificationConfirmation = ({commonconfigurations, confirmationverificationconfigurations}) => {
    const [show, setShow] = useState(false);
    const [tandC_Check, setTandC_Check] = useState(false);
    const { cdrData = {} } = useSelector((store) => store);
    const { cdrPlanType } = cdrData;
    const isFreePlan = cdrPlanType === "FREE"; //getItemOfSessionStorage('CDR') !== 'Subscribe';
    const handleToggle = () => {
        setShow(!show);
    }
    const handleCheck = (check) =>{
        if(check === "checked"){
        setTandC_Check(true);
        }else{
        setTandC_Check(false)
        }
    }
    
    return (
        <div className='sprint17-verification-conent sprint17_white_bg'>
            <div className="sprint17-verifi-sec02">
                <div className='sprint17-form-row'>
                  <div className='sprint17-ver001'>
                    <h5>{confirmationverificationconfigurations?.title}</h5>
                  </div>
                  <div className='sprint17-mnumber'>
                    {/* <h5>66566456</h5> */}
                  </div>
                </div>

                <div className='sprint17-text-field m-auto'>
                  <div>
                  <div className="sp16-verification-success">
                  <Lottie animationData={verified} loop={true} />
                  </div>
                    {/* <img src={process.env.PUBLIC_URL + '/assets/images/sprint17/verification.svg'} /> */}
                  </div>
                  <p>
                    {confirmationverificationconfigurations?.desc}
                  </p>
                </div>

                <div>
                  <div className="d-flex justify-content-center">
                    <button class="custom_btn custom_btn_primary btn_block w-50 sp16_custom_btn w-100"
                      onClick={handleToggle}>
                      {confirmationverificationconfigurations?.button_text}
                    </button>
                  </div>
                </div>

              </div>
              {show && 
                <TermsAndConditions 
                  show={show}
                  toggleModal={handleToggle} 
                  handleCheck={handleCheck} 
                  commonconfigurations={commonconfigurations} 
                  redirectUrl={isFreePlan ? "call-details" : "choose"} 
                  segmentId={commonconfigurations?.confirm_terms_segmentid } 
                  confirmationverificationconfigurations={confirmationverificationconfigurations}
                /> 
              }
        </div>
    )
}
export default VerificationConfirmation;